export const RequestModalDetail = ({
  label,
  value,
}: {
  label: string;
  value: string;
}) => {
  return (
    <div className="text-ib-pt-main mb-2">
      <label className="text-ib-pt-color-gray-1000 mb-[0.5]">{label}</label>
      <p className="text-ib-pt-color-neutral-800 font-ib-bold">{value}</p>
    </div>
  );
};
